'use client';

import Physics from '../../../src/routes/Physics';

export default function PhysicsClient() {
  return <Physics />;
}
